import { AmbientLight, Color, DirectionalLight, OrthographicCamera, PerspectiveCamera, PointLight, Scene, Vector3, WebGLRenderer } from "three";
import { GraphicsContext } from "./GraphicsContext";
import { OrbitControls } from "three/examples/jsm/Addons.js";

export class OrthographicContext extends GraphicsContext {

    public orthographicCamera = () => this.camera as OrthographicCamera;

    resizeCanvasToDisplaySize() {
        const canvas = this.renderer.domElement;
        const width = this.containerElement.clientWidth;
        const height = this.containerElement.clientHeight;

        if (canvas.width !== width || canvas.height !== height) {
            this.renderer.setSize(width, height, true);
            var orthoCamera = this.orthographicCamera();
            orthoCamera.left = width / -2;
            orthoCamera.right = width / 2;
            orthoCamera.top = height / 2;
            orthoCamera.bottom = height / -2;
            orthoCamera.updateProjectionMatrix();
        }
    }

    static createDefault(containerElement: HTMLElement): OrthographicContext {
        let width = containerElement.clientWidth;
        let height = containerElement.clientHeight;
        const scene = new Scene();
        scene.background = new Color(1,1,1);

        const aspectRatio = width / height;
        const camera = new OrthographicCamera(-1, 4, 2.7, -0.7, 0.5, 20); //new OrthographicCamera(width / -2, width / 2, height / 2, height / -2, 1, 1000);
        
        camera.position.set(0,0,3);
        // camera.lookAt(new Vector3(0,-1,0));
        
        const renderer = new WebGLRenderer({antialias: true});
        renderer.setSize(width, height);
        containerElement.appendChild(renderer.domElement);

        //scene.add(new AmbientLight(), new DirectionalLight().translateZ(1));

        // LIGHTS
        let ambientLight = new AmbientLight( 0xffffff, 10 );

        scene.add(ambientLight);
    

        const graphicsContext = new  OrthographicContext(scene, camera, renderer, containerElement);

        return graphicsContext;
    }
}